// Stores all dashboard state values which should be saved for the current dashboard

import { ALL_MODELS, MODEL_STATES } from "./constants";
import { correlationType } from "./dashboard/VariableCorrelations/CorrelationChart";
import { batchDataType } from "./helpers/processBatchData";
import Column from "./MachineLearning/Column";
import Dataset from "./MachineLearning/Dataset";
import {
	catModelPredsObj,
	modelPredictionsType,
	personaType,
	stateTypeF,
} from "./state";

export function getSaveState() {
	let saveState = {
		_loaded: true,

		dashboardName: "",
		dataset: new Dataset("1,2,3", false),
		savedModels: [] as any[],
		readOnly: true,

		// Dashboard Tabs
		dataUpload: {
			fileName: "Sales Leads.csv",
			numericHistSelected: "Minutes on Website",
			catHistSelected: "Purchased",
			dataIngestionHistData: [
				[1, 2, 3],
				[1, 2, 3],
			] as number[][],
			histTabSelected: 0,
		},
		cleanData: {
			cleanDataFiltersApplied: [],
			cleanDataFilters: [],
			autoFilters: [],
			cleanHistSelected: "Minutes on Website",
			cleanRowsSelected: {},
			cleanRowsSelectedApplied: {},
			allRowsDropped: {},
			cleanHistData: [
				[1, 2, 3],
				[1, 2, 3],
			] as number[][],
			valuesModified: {},
		},
		correlations: {
			correlations: undefined as correlationType,
			dualChartSelected: ["a", "b"],
		},
		modelTraining: {
			valueToPredict: "",
			modelStates: newObj(Object.values(ALL_MODELS), MODEL_STATES.ready),
			totalTrainProgress: 0,
			modelProgress: newObj(Object.values(ALL_MODELS), 0),
			modelR2: 0,
			modelPredictions: {
				yTest: [1, 2],
				yHat: [1, 2],
			} as modelPredictionsType,
			catModelPredictions: {} as catModelPredsObj,
			isFastTrainingSelected: false,
		},
		variableImportance: {
			varImpact: {},
			varImportance: {},
			impactVarSelected: "",
			impactClassSelected: "",
		},
		personaPrediction: {
			personas: [] as personaType[],
			personaselected: 0,
		},
		batchPrediction: {
			batchHistData: [] as number[][],
			batchData: undefined as batchDataType,
			batchFilteredData: undefined,
		},
		topicModeling: {
			colorBySentiment: false,
			varSelected: 0,
		},
		sentiment: { varSelected: 0, posCloudSelected: true },
	};
	return saveState;
}

export function setSaveStateFromJSON(obj) {
	// Grabs only the fields needed for saveState from obj
	const keys1 = Object.keys(obj);
	const saveState = getSaveState();
	for (let key1 of keys1) {
		if (key1 in saveState) {
			if (typeof obj[key1] == "object") {
				const keys2 = Object.keys(obj[key1]);
				for (let key2 of keys2) {
					if (key2 in obj[key1]) {
						if (obj[key1][key2] !== undefined) {
							saveState[key1][key2] = obj[key1][key2];
						}
					}
				}
			} else if (obj[key1] !== undefined) {
				saveState[key1] = obj[key1];
			}
		}
	}
	return saveState;
}

export let saveStateType = getSaveState();

function loadDataset(value: Object) {
	let parsed = value;
	let tmp = Object.assign(new Dataset(undefined, undefined), parsed);
	tmp.columns = tmp.columns.map((col) =>
		Object.assign(new Column(undefined, undefined), col)
	);
	return tmp;
}
export function newObj(arr: string[], n: number) {
	let obj = {};
	for (let i = 0; i < arr.length; i++) {
		obj[arr[i]] = n;
	}
	return obj;
}
